module.exports = "https://cdn-shared.mathletics.com/mathsaz/99/assets/images/676108b818e95235f11fcaa3bf0d5918.svg";